import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextCropper from '@omilia/text-cropper';

import { testSetType } from 'types';
import './style.scss';

export default class TestSetTab extends Component {
  static propTypes = {
    deselectTestSet: PropTypes.func.isRequired,
    selectedTestSet: testSetType.isRequired,
  };

  state = {
    hasCloseIcon: false,
  };

  showIcon = () => {
    this.setState({
      hasCloseIcon: true,
    });
  };

  hideIcon = () => {
    this.setState({
      hasCloseIcon: false,
    });
  };

  /* eslint-disable jsx-a11y/anchor-has-content */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  /* eslint-disable jsx-a11y/anchor-is-valid */
  render() {
    const { selectedTestSet, deselectTestSet } = this.props;

    return (
      <div
        styleName="tab"
        onMouseEnter={this.showIcon}
        onMouseLeave={this.hideIcon}
      >
        <TextCropper styleName="tab__name" text={selectedTestSet.name} />

        {this.state.hasCloseIcon && (
          <a className="icon-close" onClick={deselectTestSet} />
        )}
      </div>
    );
  }
}
